module.exports = __webpack_public_path__ + "img/parker-trumbull-card.94d2cf5d.webp";